export type Language = 'en' | 'ua' | 'ru'

export const translations = {
  // Navigation
  nav: {
    home: { en: 'Home', ua: 'Головна', ru: 'Главная' },
    services: { en: 'Services', ua: 'Послуги', ru: 'Услуги' },
    prices: { en: 'Prices', ua: 'Ціни', ru: 'Цены' },
    about: { en: 'About Us', ua: 'Про нас', ru: 'О нас' },
    contact: { en: 'Contact', ua: 'Контакти', ru: 'Контакты' },
    bookOnline: { en: 'Book Online', ua: 'Записатись', ru: 'Записаться' },
  },

  // Hero Section
  hero: {
    badge: {
      en: 'Accepting new patients',
      ua: 'Ми розмовляємо українською',
      ru: 'Мы говорим по-русски',
    },
    title: {
      en: 'Private Dental Clinic in',
      ua: 'Український стоматолог у Лондоні —',
      ru: 'Русскоязычный стоматолог в Лондоне —',
    },
    titleHighlight: {
      en: 'Angel, London',
      ua: 'Dentico Clinic',
      ru: 'Dentico Clinic',
    },
    description: {
      en: 'Dentico Clinic is a modern private dental clinic in Angel, Central London. We provide high-quality dental care using advanced technology, experienced clinicians, and transparent private fees.',
      ua: 'Dentico Clinic — приватна стоматологічна клініка в Лондоні з українськомовними лікарями. Ми зрозуміло пояснюємо лікування, працюємо чесно та використовуємо сучасне обладнання.',
      ru: 'Dentico Clinic — частная стоматология в Лондоне с русскоязычными врачами. Понятные объяснения лечения и современное оборудование.',
    },
    whatsapp: { en: 'WhatsApp Us', ua: 'WhatsApp', ru: 'WhatsApp' },
  },

  // Features
  features: {
    nativeLanguage: {
      en: 'Experienced private dentists',
      ua: 'Українськомовні стоматологи',
      ru: 'Русскоязычные стоматологи',
    },
    modernDentistry: {
      en: 'Modern digital dentistry',
      ua: 'Сучасне обладнання',
      ru: 'Современное оборудование',
    },
    experiencedDentists: {
      en: 'Experienced private dentists',
      ua: 'Досвідчені лікарі',
      ru: 'Опытные врачи',
    },
    clearPlans: {
      en: 'Clear treatment plans',
      ua: 'Зрозуміле пояснення лікування',
      ru: 'Понятные объяснения лечения',
    },
    honestPricing: {
      en: 'Honest private pricing',
      ua: 'Чесні ціни',
      ru: 'Честные цены',
    },
    excellentReviews: {
      en: 'Excellent patient reviews',
      ua: 'Онлайн-запис',
      ru: 'Онлайн-запись',
    },
    convenientLocation: {
      en: 'Convenient location near Angel station',
      ua: 'Зручне розташування (Angel)',
      ru: 'Удобное расположение (Angel)',
    },
  },

  // Services Section
  services: {
    title: {
      en: 'Comprehensive Dental Services',
      ua: 'Наші Послуги',
      ru: 'Наши Услуги',
    },
    subtitle: {
      en: 'From routine check-ups to complex smile makeovers, our experienced team is here to help you achieve optimal oral health.',
      ua: 'Повний спектр стоматологічних послуг від професійної гігієни до складного протезування.',
      ru: 'Полный спектр стоматологических услуг от профессиональной гигиены до сложного протезирования.',
    },
    learnMore: { en: 'Learn more', ua: 'Детальніше', ru: 'Подробнее' },
    viewAll: { en: 'View All Services', ua: 'Всі послуги', ru: 'Все услуги' },
    general: {
      title: {
        en: 'General Dentistry',
        ua: 'Загальна стоматологія',
        ru: 'Общая стоматология',
      },
      desc: {
        en: 'Comprehensive check-ups and hygiene services for your oral health.',
        ua: "Комплексні огляди та гігієна для здоров'я вашої посмішки.",
        ru: 'Комплексные осмотры и гигиена для здоровья вашей улыбки.',
      },
      fullDesc: {
        en: 'Regular check-ups and hygiene appointments are the foundation of a healthy smile. We focus on prevention and early detection.',
        ua: 'Регулярні огляди та гігієнічні процедури є основою здорової посмішки. Ми зосереджуємось на профілактиці та ранньому виявленні.',
        ru: 'Регулярные осмотры и гигиенические процедуры являются основой здоровой улыбки. Мы фокусируемся на профилактике и раннем выявлении.',
      },
      benefits: {
        en: [
          'Comprehensive oral health check',
          'Scale and polish',
          'Oral cancer screening',
          'Preventative advice',
        ],
        ua: [
          'Комплексний огляд порожнини рота',
          'Чистка та полірування',
          'Скринінг раку порожнини рота',
          'Профілактичні поради',
        ],
        ru: [
          'Комплексный осмотр полости рта',
          'Чистка и полировка',
          'Скрининг рака полости рта',
          'Профилактические советы',
        ],
      },
    },
    fillings: {
      title: {
        en: 'Dental Fillings in London',
        ua: 'Пломбування та реставрація зубів',
        ru: 'Пломбирование зубов',
      },
      desc: {
        en: 'Aesthetic white fillings to restore teeth naturally.',
        ua: 'Естетичні фотополімерні пломби, що виглядають природно.',
        ru: 'Эстетические фотополимерные пломбы, которые выглядят естественно.',
      },
      fullDesc: {
        en: 'We use high-quality white composite fillings that match your natural tooth shade. No more unsightly metal amalgam fillings.',
        ua: 'Ми використовуємо високоякісні білі композитні пломби, які відповідають природному відтінку ваших зубів.',
        ru: 'Мы используем высококачественные белые композитные пломбы, которые соответствуют естественному оттенку ваших зубов.',
      },
      benefits: {
        en: [
          'Natural appearance',
          'Mercury-free materials',
          'Durable and long-lasting',
          'Minimally invasive',
        ],
        ua: [
          'Природний вигляд',
          'Матеріали без ртуті',
          'Довговічність',
          'Мінімально інвазивні',
        ],
        ru: [
          'Естественный вид',
          'Материалы без ртути',
          'Долговечность',
          'Минимально инвазивные',
        ],
      },
    },
    rootCanal: {
      title: {
        en: 'Root Canal Treatment in London',
        ua: 'Лікування та перелічування каналів',
        ru: 'Лечение каналов',
      },
      desc: {
        en: 'Pain-free treatment to save infected teeth.',
        ua: 'Безболісне лікування для збереження інфікованих зубів.',
        ru: 'Безболезненное лечение для сохранения инфицированных зубов.',
      },
      fullDesc: {
        en: 'Modern root canal treatment is virtually pain-free. We save infected teeth that would otherwise need extraction.',
        ua: 'Сучасне лікування кореневих каналів практично безболісне. Ми зберігаємо інфіковані зуби, які інакше потребували б видалення.',
        ru: 'Современное лечение корневых каналов практически безболезненно. Мы сохраняем инфицированные зубы, которые иначе потребовали бы удаления.',
      },
      benefits: {
        en: [
          'Save your natural tooth',
          'Relieve tooth pain immediately',
          'Advanced rotary technology',
          'High success rate',
        ],
        ua: [
          'Збережіть свій природний зуб',
          'Негайне полегшення болю',
          'Сучасна ротаційна технологія',
          'Високий відсоток успіху',
        ],
        ru: [
          'Сохраните свой естественный зуб',
          'Немедленное облегчение боли',
          'Современная ротационная технология',
          'Высокий процент успеха',
        ],
      },
    },
    crowns: {
      title: {
        en: 'Dental Crowns in London',
        ua: 'Коронки та протезування',
        ru: 'Зубные коронки',
      },
      desc: {
        en: 'Durable and natural-looking restoration for damaged teeth.',
        ua: 'Надійне та естетичне відновлення пошкоджених зубів.',
        ru: 'Надежное и эстетичное восстановление поврежденных зубов.',
      },
      fullDesc: {
        en: 'Restore broken or weak teeth with our custom-made ceramic crowns. They look and feel just like your natural teeth.',
        ua: 'Відновіть зламані або слабкі зуби за допомогою наших керамічних коронок на замовлення.',
        ru: 'Восстановите сломанные или слабые зубы с помощью наших керамических коронок на заказ.',
      },
      benefits: {
        en: [
          'Strengthen damaged teeth',
          'Improve appearance',
          'Long-lasting solution',
          'Custom color matching',
        ],
        ua: [
          'Зміцнення пошкоджених зубів',
          'Покращення зовнішнього вигляду',
          'Довготривале рішення',
          'Індивідуальний підбір кольору',
        ],
        ru: [
          'Укрепление поврежденных зубов',
          'Улучшение внешнего вида',
          'Долгосрочное решение',
          'Индивидуальный подбор цвета',
        ],
      },
    },
    hygiene: {
      title: {
        en: 'Dental Hygiene in London',
        ua: 'Професійна гігієна',
        ru: 'Профессиональная гигиена',
      },
      desc: {
        en: 'Professional cleaning for a healthier smile.',
        ua: 'Професійна чистка для здорової посмішки.',
        ru: 'Профессиональная чистка для здоровой улыбки.',
      },
      fullDesc: {
        en: 'Regular professional cleaning removes plaque and tartar that brushing alone cannot reach, preventing gum disease and tooth decay.',
        ua: 'Регулярна професійна чистка видаляє наліт і зубний камінь, запобігаючи захворюванням ясен та карієсу.',
        ru: 'Регулярная профессиональная чистка удаляет налет и зубной камень, предотвращая заболевания десен и кариес.',
      },
      benefits: {
        en: [
          'Remove plaque and tartar',
          'Prevent gum disease',
          'Fresher breath',
          'Brighter smile',
        ],
        ua: [
          'Видалення нальоту та каменю',
          'Профілактика захворювань ясен',
          'Свіже дихання',
          'Яскравіша посмішка',
        ],
        ru: [
          'Удаление налета и камня',
          'Профилактика заболеваний десен',
          'Свежее дыхание',
          'Яркая улыбка',
        ],
      },
    },
    whitening: {
      title: {
        en: 'Teeth Whitening in London',
        ua: 'Відбілювання зубів',
        ru: 'Отбеливание зубов',
      },
      desc: {
        en: 'Professional whitening for a brighter smile.',
        ua: 'Професійне відбілювання для яскравої посмішки.',
        ru: 'Профессиональное отбеливание для яркой улыбки.',
      },
      fullDesc: {
        en: 'Our professional whitening treatments can lighten your teeth by several shades, giving you a confident, radiant smile.',
        ua: 'Наші професійні процедури відбілювання можуть освітлити ваші зуби на кілька тонів.',
        ru: 'Наши профессиональные процедуры отбеливания могут осветлить ваши зубы на несколько тонов.',
      },
      benefits: {
        en: [
          'Safe and effective',
          'Long-lasting results',
          'Custom treatment',
          'Immediate improvement',
        ],
        ua: [
          'Безпечно та ефективно',
          'Тривалий результат',
          'Індивідуальний підхід',
          'Негайне покращення',
        ],
        ru: [
          'Безопасно и эффективно',
          'Длительный результат',
          'Индивидуальный подход',
          'Немедленное улучшение',
        ],
      },
    },
    extraction: {
      title: {
        en: 'Tooth Extraction in London',
        ua: 'Видалення зубів',
        ru: 'Удаление зубов',
      },
      desc: {
        en: 'Safe and gentle tooth removal when needed.',
        ua: 'Безпечне та делікатне видалення зубів.',
        ru: 'Безопасное и деликатное удаление зубов.',
      },
      fullDesc: {
        en: 'When a tooth cannot be saved, we perform gentle extractions with minimal discomfort and provide guidance for healing.',
        ua: 'Коли зуб неможливо зберегти, ми проводимо делікатне видалення з мінімальним дискомфортом.',
        ru: 'Когда зуб невозможно сохранить, мы проводим деликатное удаление с минимальным дискомфортом.',
      },
      benefits: {
        en: [
          'Gentle technique',
          'Pain management',
          'Quick recovery',
          'Aftercare guidance',
        ],
        ua: [
          'Делікатна техніка',
          'Знеболення',
          'Швидке відновлення',
          'Рекомендації по догляду',
        ],
        ru: [
          'Деликатная техника',
          'Обезболивание',
          'Быстрое восстановление',
          'Рекомендации по уходу',
        ],
      },
    },
    cosmetic: {
      title: {
        en: 'Cosmetic Injections',
        ua: "Ін'єкційна косметологія",
        ru: 'Инъекционная косметология',
      },
      desc: {
        en: 'Facial aesthetics to complement your smile.',
        ua: 'Естетичні процедури для обличчя.',
        ru: 'Эстетические процедуры для лица.',
      },
      fullDesc: {
        en: 'Enhance your appearance with our range of cosmetic injection treatments performed by trained professionals.',
        ua: 'Покращіть свій зовнішній вигляд за допомогою наших косметичних процедур.',
        ru: 'Улучшите свой внешний вид с помощью наших косметических процедур.',
      },
      benefits: {
        en: [
          'Natural results',
          'Minimal downtime',
          'Trained professionals',
          'Personalized treatment',
        ],
        ua: [
          'Природний результат',
          'Мінімальний час відновлення',
          'Кваліфіковані спеціалісти',
          'Індивідуальний підхід',
        ],
        ru: [
          'Естественный результат',
          'Минимальное время восстановления',
          'Квалифицированные специалисты',
          'Индивидуальный подход',
        ],
      },
    },
    smileMakeover: {
      title: {
        en: 'Smile Makeover in London | Veneers, Bonding & Cosmetic Dentistry',
        ua: 'Smile Makeover — Естетична стоматологія в Лондоні',
        ru: 'Smile Makeover — Эстетическая стоматология в Лондоне',
      },
      desc: {
        en: 'Transform your smile with veneers, bonding, and whitening.',
        ua: 'Вініри, накладки, вкладки, відбілювання та повна трансформація посмішки.',
        ru: 'Виниры, накладки, вкладки, отбеливание и полная трансформация улыбки.',
      },
      fullDesc: {
        en: 'A Smile Makeover is a comprehensive cosmetic dental treatment that combines multiple procedures to transform your smile. Using digital smile design, we create a personalized treatment plan that may include porcelain veneers, composite bonding, teeth whitening, and muscle relaxation treatments. Our advanced photo protocol and 3D scanning ensure predictable, stunning results.',
        ua: "Smile Makeover — це комплексне естетичне лікування, яке поєднує кілька процедур для повної трансформації вашої посмішки. Використовуючи цифровий дизайн посмішки, ми створюємо індивідуальний план лікування, який може включати керамічні вініри, композитні накладки, вкладки, відбілювання та розслаблення м'язів. Наш сучасний фотопротокол та 3D-сканування забезпечують передбачуваний та вражаючий результат.",
        ru: 'Smile Makeover — это комплексное эстетическое лечение, которое объединяет несколько процедур для полной трансформации вашей улыбки. Используя цифровой дизайн улыбки, мы создаем индивидуальный план лечения, который может включать керамические виниры, композитные накладки, вкладки, отбеливание и расслабление мышц. Наш современный фотопротокол и 3D-сканирование обеспечивают предсказуемый и впечатляющий результат.',
      },
      seoDescription: {
        en: 'Professional Smile Makeover in Angel, London. Transform your smile with porcelain veneers, composite bonding, teeth whitening. Digital smile design, before & after photos. Book consultation at Dentico Clinic.',
        ua: 'Професійний Smile Makeover в Лондоні, район Angel. Трансформація посмішки: вініри, накладки, відбілювання. Цифровий дизайн посмішки, фото до та після. Українськомовний стоматолог. Запис у Dentico Clinic.',
        ru: 'Профессиональный Smile Makeover в Лондоне, район Angel. Трансформация улыбки: виниры, накладки, отбеливание. Цифровой дизайн улыбки, фото до и после. Русскоязычный стоматолог. Запись в Dentico Clinic.',
      },
      benefits: {
        en: [
          'Digital Smile Design with 3D scanning',
          'Porcelain veneers & composite bonding',
          'Professional teeth whitening',
          'Muscle relaxation treatments',
          'Comprehensive photo protocol',
          'Natural-looking, long-lasting results',
        ],
        ua: [
          'Цифровий дизайн посмішки з 3D-скануванням',
          'Керамічні вініри та композитні накладки',
          'Професійне відбілювання зубів',
          "Розслаблення м'язів обличчя",
          'Комплексний фотопротокол',
          'Природний та довготривалий результат',
        ],
        ru: [
          'Цифровой дизайн улыбки с 3D-сканированием',
          'Керамические виниры и композитные накладки',
          'Профессиональное отбеливание зубов',
          'Расслабление мышц лица',
          'Комплексный фотопротокол',
          'Естественный и долговечный результат',
        ],
      },
      treatments: {
        en: [
          {
            name: 'Porcelain Veneers',
            desc: 'Ultra-thin ceramic shells for a perfect smile',
          },
          {
            name: 'Composite Bonding',
            desc: 'Tooth-colored resin to reshape and restore',
          },
          {
            name: 'Teeth Whitening',
            desc: 'Professional whitening for a brighter smile',
          },
          {
            name: 'Inlays & Onlays',
            desc: 'Custom ceramic restorations for damaged teeth',
          },
          {
            name: 'Muscle Relaxation',
            desc: 'Facial aesthetics to complement your smile',
          },
          {
            name: '3D Scanning & Photo Protocol',
            desc: 'Digital planning for predictable results',
          },
        ],
        ua: [
          {
            name: 'Керамічні вініри',
            desc: 'Ультратонкі керамічні накладки для ідеальної посмішки',
          },
          {
            name: 'Композитні накладки',
            desc: 'Реставрація зубів композитним матеріалом',
          },
          {
            name: 'Відбілювання зубів',
            desc: 'Професійне відбілювання для яскравої посмішки',
          },
          {
            name: 'Вкладки та накладки',
            desc: 'Індивідуальні керамічні реставрації',
          },
          {
            name: "Розслаблення м'язів",
            desc: 'Естетичні процедури для обличчя',
          },
          {
            name: '3D-сканування та фотопротокол',
            desc: 'Цифрове планування для передбачуваного результату',
          },
        ],
        ru: [
          {
            name: 'Керамические виниры',
            desc: 'Ультратонкие керамические накладки для идеальной улыбки',
          },
          {
            name: 'Композитные накладки',
            desc: 'Реставрация зубов композитным материалом',
          },
          {
            name: 'Отбеливание зубов',
            desc: 'Профессиональное отбеливание для яркой улыбки',
          },
          {
            name: 'Вкладки и накладки',
            desc: 'Индивидуальные керамические реставрации',
          },
          {
            name: 'Расслабление мышц',
            desc: 'Эстетические процедуры для лица',
          },
          {
            name: '3D-сканирование и фотопротокол',
            desc: 'Цифровое планирование для предсказуемого результата',
          },
        ],
      },
      gallery: {
        title: {
          en: 'Before & After Results',
          ua: 'Результати: До та Після',
          ru: 'Результаты: До и После',
        },
        uploadPlaceholder: {
          en: 'Photo coming soon',
          ua: 'Фото незабаром',
          ru: 'Фото скоро',
        },
      },
      video: {
        title: {
          en: 'Watch Our Smile Transformations',
          ua: 'Дивіться трансформації посмішок',
          ru: 'Смотрите трансформации улыбок',
        },
        placeholder: {
          en: 'Video coming soon',
          ua: 'Відео незабаром',
          ru: 'Видео скоро',
        },
      },
    },
  },

  // Prices Page
  prices: {
    title: {
      en: 'Private Dental Fees in London',
      ua: 'Ціни на стоматологічні послуги',
      ru: 'Цены на стоматологические услуги',
    },
    subtitle: {
      en: 'Transparent pricing for all our dental treatments. No hidden fees.',
      ua: 'Прозорі ціни на всі наші стоматологічні послуги. Без прихованих платежів.',
      ru: 'Прозрачные цены на все наши стоматологические услуги. Без скрытых платежей.',
    },
    note: {
      en: 'Exact fees depend on clinical assessment. Please book a consultation for a personalized treatment plan.',
      ua: 'Точна вартість залежить від клінічної оцінки. Запишіться на консультацію для індивідуального плану лікування.',
      ru: 'Точная стоимость зависит от клинической оценки. Запишитесь на консультацию для индивидуального плана лечения.',
    },
    consultation: {
      en: 'Consultation',
      ua: 'Консультація',
      ru: 'Консультация',
    },
    consultationPrice: { en: '£20', ua: '£20', ru: '£20' },
    examination: {
      en: 'Dental Examination',
      ua: 'Огляд стоматолога',
      ru: 'Осмотр стоматолога',
    },
    examinationPrice: { en: '£50', ua: '£35', ru: '£35' },
    xray: {
      en: 'X-Ray (per image)',
      ua: 'Рентген (1 знімок)',
      ru: 'Рентген (1 снимок)',
    },
    xrayPrice: { en: '£20', ua: '£20', ru: '£20' },
    filling: { en: 'Dental Filling', ua: 'Пломба', ru: 'Пломба' },
    fillingPrice: { en: '£130–£220', ua: '£100–£170', ru: '£100–£170' },
    rootCanal: {
      en: 'Root Canal Treatment',
      ua: 'Лікування каналів',
      ru: 'Лечение каналов',
    },
    rootCanalPrice: { en: 'from £320', ua: 'від £350', ru: 'от £350' },
    crown: { en: 'Dental Crown', ua: 'Коронка', ru: 'Коронка' },
    crownPrice: { en: '£600–£850', ua: '£500–£650', ru: '£500–£650' },
    hygiene: {
      en: 'Dental Hygiene (Scale & Polish)',
      ua: 'Гігієна (ультразвук + полірування)',
      ru: 'Гигиена (ультразвук + полировка)',
    },
    hygienePrice: { en: '£120', ua: '£100', ru: '£100' },
    hygieneAirflow: {
      en: 'Dental Hygiene with Airflow',
      ua: 'Гігієна з Airflow',
      ru: 'Гигиена с Airflow',
    },
    hygieneAirflowPrice: { en: '£150', ua: '£130', ru: '£130' },
    whitening: { en: 'Teeth Whitening', ua: 'Відбілювання', ru: 'Отбеливание' },
    whiteningPrice: { en: 'from £250', ua: 'від £250', ru: 'от £250' },
    extraction: {
      en: 'Tooth Extraction',
      ua: 'Видалення зуба',
      ru: 'Удаление зуба',
    },
    extractionPrice: { en: 'from £150', ua: 'від £150', ru: 'от £150' },
    wisdomTooth: {
      en: 'Wisdom Tooth Extraction',
      ua: 'Видалення зуба мудрості',
      ru: 'Удаление зуба мудрости',
    },
    wisdomToothPrice: { en: 'from £200', ua: 'від £200', ru: 'от £200' },
    veneer: {
      en: 'Porcelain Veneer',
      ua: 'Керамічний вінір',
      ru: 'Керамический винир',
    },
    veneerPrice: { en: 'from £650', ua: 'від £500', ru: 'от £500' },
    compositeBonding: {
      en: 'Composite Bonding (per tooth)',
      ua: 'Композитна реставрація (1 зуб)',
      ru: 'Композитная реставрация (1 зуб)',
    },
    compositeBondingPrice: { en: 'from £250', ua: 'від £170', ru: 'от £170' },
    implant: {
      en: 'Dental Implant',
      ua: 'Зубний імплант',
      ru: 'Зубной имплант',
    },
    implantPrice: { en: 'from £1,800', ua: 'від £1,800', ru: 'от £1,800' },
    bridge: {
      en: 'Dental Bridge (per unit)',
      ua: 'Зубний міст (1 одиниця)',
      ru: 'Зубной мост (1 единица)',
    },
    bridgePrice: { en: 'from £500', ua: 'від £450', ru: 'от £450' },
    denture: {
      en: 'Partial Denture',
      ua: 'Частковий протез',
      ru: 'Частичный протез',
    },
    denturePrice: { en: 'from £600', ua: 'від £550', ru: 'от £550' },
    fullDenture: {
      en: 'Full Denture',
      ua: 'Повний протез',
      ru: 'Полный протез',
    },
    fullDenturePrice: { en: 'from £900', ua: 'від £850', ru: 'от £850' },
    emergencyAppointment: {
      en: 'Emergency Appointment',
      ua: 'Екстрений прийом',
      ru: 'Экстренный прием',
    },
    emergencyAppointmentPrice: { en: '£50', ua: '£50', ru: '£50' },
    bookCta: {
      en: 'Book Your Consultation',
      ua: 'Записатись на консультацію',
      ru: 'Записаться на консультацию',
    },
  },

  // Location CTA
  location: {
    title: {
      en: 'Visit us in Angel, Islington',
      ua: 'Завітайте до нас в Angel',
      ru: 'Приходите к нам в Angel',
    },
    description: {
      en: 'Conveniently located at 360-364 City Rd, London EC1V 2PY. We are open late evenings and weekends for your convenience.',
      ua: 'Зручне розташування за адресою 360-364 City Rd, London EC1V 2PY. Ми працюємо у вечірній час та вихідні.',
      ru: 'Удобное расположение по адресу 360-364 City Rd, London EC1V 2PY. Мы работаем в вечернее время и выходные.',
    },
    getDirections: { en: 'Get Directions', ua: 'Маршрут', ru: 'Маршрут' },
    bookAppointment: {
      en: 'Book Appointment',
      ua: 'Записатись',
      ru: 'Записаться',
    },
  },

  // Footer
  footer: {
    location: { en: 'Location', ua: 'Локація', ru: 'Локация' },
    hours: { en: 'Opening Hours', ua: 'Години роботи', ru: 'Часы работы' },
    contact: { en: 'Contact Us', ua: 'Контакти', ru: 'Контакты' },
    address: {
      en: '360-364 City Rd, London EC1V 2PY',
      ua: '360-364 City Rd, London EC1V 2PY',
      ru: '360-364 City Rd, London EC1V 2PY',
    },
    rights: {
      en: 'All rights reserved.',
      ua: 'Всі права захищено.',
      ru: 'Все права защищены.',
    },
    whatsappChat: {
      en: 'WhatsApp Chat',
      ua: 'WhatsApp Чат',
      ru: 'WhatsApp Чат',
    },
    monFri: { en: 'Mon - Fri', ua: 'Пн - Пт', ru: 'Пн - Пт' },
    saturday: { en: 'Saturday', ua: 'Субота', ru: 'Суббота' },
    sunday: { en: 'Sunday', ua: 'Неділя', ru: 'Воскресенье' },
    closed: { en: 'Closed', ua: 'Зачинено', ru: 'Закрыто' },
  },

  // About Page
  about: {
    title: {
      en: 'About Dentico Clinic',
      ua: 'Про Dentico Clinic',
      ru: 'О Dentico Clinic',
    },
    subtitle: {
      en: 'A modern private dental practice in the heart of Angel, dedicated to providing exceptional care in a relaxed environment.',
      ua: 'Сучасна приватна стоматологія в серці Angel, де ви можете почуватися як вдома.',
      ru: 'Современная частная стоматология в сердце Angel, где вы можете чувствовать себя как дома.',
    },
    storyTitle: { en: 'Our Story', ua: 'Наша історія', ru: 'Наша история' },
    storyP1: {
      en: 'Founded with a vision to transform the dental experience, Dentico Clinic brings together advanced technology and compassionate care. We believe that visiting the dentist should be a positive experience.',
      ua: 'Dentico Clinic створена з метою змінити уявлення про стоматологію. Ми поєднали передові технології з щирою турботою про пацієнтів. Особливу увагу ми приділяємо комфорту наших українських пацієнтів у Лондоні.',
      ru: 'Dentico Clinic создана с целью изменить представление о стоматологии. Мы объединили передовые технологии с искренней заботой о пациентах. Особое внимание мы уделяем комфорту наших русскоязычных пациентов в Лондоне.',
    },
    storyP2: {
      en: 'Located conveniently in Angel, Islington, our modern facility is designed for your comfort. From routine check-ups to complex cosmetic makeovers, our team is here to support your journey to a healthy, confident smile.',
      ua: 'Розташована в зручному районі Angel, наша клініка оснащена найсучаснішим обладнанням. Наші лікарі розмовляють українською, тому ви можете бути впевнені, що вас зрозуміють правильно.',
      ru: 'Расположенная в удобном районе Angel, наша клиника оснащена самым современным оборудованием. Наши врачи говорят по-русски, поэтому вы можете быть уверены, что вас поймут правильно.',
    },
    meetTeam: {
      en: 'Contact Us',
      ua: "Зв'язатись з нами",
      ru: 'Связаться с нами',
    },
    valuesTitle: {
      en: 'Our Core Values',
      ua: 'Наші цінності',
      ru: 'Наши ценности',
    },
    valuesSubtitle: {
      en: 'These principles guide everything we do at Dentico Clinic.',
      ua: 'Принципи, якими ми керуємося в роботі кожного дня.',
      ru: 'Принципы, которыми мы руководствуемся в работе каждый день.',
    },
    values: {
      patientCare: {
        title: {
          en: 'Patient Care',
          ua: 'Турбота про пацієнта',
          ru: 'Забота о пациенте',
        },
        desc: {
          en: 'We treat every patient with kindness, respect, and empathy.',
          ua: 'Ми ставимося до кожного пацієнта з добротою та повагою.',
          ru: 'Мы относимся к каждому пациенту с добротой и уважением.',
        },
      },
      trust: {
        title: {
          en: 'Trust & Transparency',
          ua: 'Довіра та прозорість',
          ru: 'Доверие и прозрачность',
        },
        desc: {
          en: 'Clear treatment plans and honest pricing with no hidden fees.',
          ua: 'Чіткі плани лікування та чесні ціни без прихованих платежів.',
          ru: 'Понятные планы лечения и честные цены без скрытых платежей.',
        },
      },
      nativeLanguage: {
        title: { en: 'Modern Technology', ua: 'Рідна мова', ru: 'Родной язык' },
        desc: {
          en: 'Using the latest digital dentistry for precise and comfortable treatments.',
          ua: 'Спілкування українською мовою для вашого повного комфорту.',
          ru: 'Общение на русском языке для вашего полного комфорта.',
        },
      },
      expertTeam: {
        title: {
          en: 'Expert Team',
          ua: 'Команда експертів',
          ru: 'Команда экспертов',
        },
        desc: {
          en: 'Highly qualified UK-registered clinicians dedicated to your oral health.',
          ua: 'Висококваліфіковані лікарі, віддані своїй справі.',
          ru: 'Высококвалифицированные врачи, преданные своему делу.',
        },
      },
    },
    ctaTitle: {
      en: 'Join Our Patient Community',
      ua: 'Запишіться на прийом',
      ru: 'Запишитесь на прием',
    },
    ctaSubtitle: {
      en: 'Experience the difference of modern, patient-centered dental care.',
      ua: 'Відчуйте різницю сучасної стоматології з рідною мовою.',
      ru: 'Почувствуйте разницу современной стоматологии с родным языком.',
    },
  },

  // Contact Page
  contact: {
    title: { en: 'Contact Us', ua: 'Контакти', ru: 'Контакты' },
    subtitle: {
      en: "We're here to help. Get in touch to book an appointment or ask any questions.",
      ua: "Ми завжди раді допомогти. Зв'яжіться з нами українською мовою.",
      ru: 'Мы всегда рады помочь. Свяжитесь с нами на русском языке.',
    },
    getInTouch: {
      en: 'Get in Touch',
      ua: 'Наші контакти',
      ru: 'Наши контакты',
    },
    visitUs: { en: 'Visit Us', ua: 'Адреса', ru: 'Адрес' },
    whatsapp: { en: 'WhatsApp', ua: 'WhatsApp', ru: 'WhatsApp' },
    whatsappDesc: {
      en: 'Fastest way to reach us',
      ua: "Найшвидший спосіб зв'язку",
      ru: 'Быстрый способ связи',
    },
    chatOnWhatsapp: {
      en: 'Chat on WhatsApp',
      ua: 'Написати в WhatsApp',
      ru: 'Написать в WhatsApp',
    },
    email: { en: 'Email', ua: 'Email', ru: 'Email' },
    openingHours: {
      en: 'Opening Hours',
      ua: 'Години роботи',
      ru: 'Часы работы',
    },
  },

  // Services Page
  servicesPage: {
    title: { en: 'Our Services', ua: 'Наші Послуги', ru: 'Наши Услуги' },
    subtitle: {
      en: 'We offer a comprehensive range of private dental treatments using the latest technology and techniques.',
      ua: 'Ми пропонуємо повний спектр приватних стоматологічних послуг з використанням найновіших технологій.',
      ru: 'Мы предлагаем полный спектр частных стоматологических услуг с использованием новейших технологий.',
    },
    bookConsultation: {
      en: 'Book Consultation',
      ua: 'Записатись на консультацію',
      ru: 'Записаться на консультацию',
    },
    readyToBook: {
      en: 'Ready to book your appointment?',
      ua: 'Готові записатись?',
      ru: 'Готовы записаться?',
    },
    readyToBookDesc: {
      en: 'Our friendly team is ready to welcome you to Dentico Clinic.',
      ua: 'Наша привітна команда готова вітати вас у Dentico Clinic.',
      ru: 'Наша приветливая команда готова приветствовать вас в Dentico Clinic.',
    },
    bookOnlineNow: {
      en: 'Book Online Now',
      ua: 'Записатись онлайн',
      ru: 'Записаться онлайн',
    },
    contactUs: { en: 'Contact Us', ua: 'Контакти', ru: 'Контакты' },
  },

  // Google Reviews
  reviews: {
    title: {
      en: 'Patient Reviews',
      ua: 'Відгуки пацієнтів',
      ru: 'Отзывы пациентов',
    },
    subtitle: {
      en: 'Rated 4.9/5 on Google',
      ua: 'Рейтинг 4.9/5 в Google',
      ru: 'Рейтинг 4.9/5 в Google',
    },
    viewAll: {
      en: 'View all reviews on Google Maps',
      ua: 'Дивитись всі відгуки на Google Maps',
      ru: 'Смотреть все отзывы на Google Maps',
    },
    review1: {
      name: { en: 'Sarah J.', ua: 'Оксана М.', ru: 'Александр В.' },
      text: {
        en: 'Absolutely amazing experience. The staff is so professional and the clinic is spotless. Highly recommend!',
        ua: 'Чудова клініка! Дуже приємно, що можна спілкуватися рідною мовою. Лікарі професіонали.',
        ru: 'Отличная клиника! Очень удобно, что врачи говорят по-русски. Рекомендую.',
      },
      date: { en: '2 weeks ago', ua: '2 тижні тому', ru: '2 недели назад' },
    },
    review2: {
      name: { en: 'Michael T.', ua: 'Андрій К.', ru: 'Наталья С.' },
      text: {
        en: 'Best dental clinic in Angel. Very transparent pricing and excellent care.',
        ua: 'Найкраща стоматологія в Лондоні. Сучасне обладнання та приємні ціни.',
        ru: 'Прекрасный сервис и профессиональные врачи. Очень довольна результатом.',
      },
      date: { en: '1 month ago', ua: '1 місяць тому', ru: '1 месяц назад' },
    },
    review3: {
      name: { en: 'Elena K.', ua: 'Марія П.', ru: 'Дмитрий И.' },
      text: {
        en: 'Finally found a dentist I can trust. The team made me feel very comfortable.',
        ua: 'Дуже задоволена візитом. Все пройшло безболісно і комфортно.',
        ru: 'Лучшая стоматология в районе Angel. Цены адекватные, качество на высоте.',
      },
      date: { en: '2 months ago', ua: '2 місяці тому', ru: '2 месяца назад' },
    },
  },

  // Trust Badge (for UA/RU)
  trustBadge: {
    title: { en: '', ua: 'Рідна мова', ru: 'Родной язык' },
    description: {
      en: '',
      ua: "Лікуйтесь комфортно без мовного бар'єру",
      ru: 'Лечитесь комфортно без языкового барьера',
    },
  },
}

// Helper function to get translation
export function t(key: string, lang: Language): string {
  const keys = key.split('.')
  let value: any = translations

  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k]
    } else {
      return key
    }
  }

  if (value && typeof value === 'object' && lang in value) {
    return value[lang]
  }

  return key
}
